import { render, staticRenderFns } from "./MailComponent.vue?vue&type=template&id=313cce94&"
import script from "./MailComponent.vue?vue&type=script&lang=js&"
export * from "./MailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports